/**
 * Malts and fermentables database.
 */

export const MALTS = [
  // Basmalter
  {
    name: 'Weyermann Pilsner Malt',
    ebc: 3.5,
    yield: 80,
    type: 'base',
    desc: 'Klassisk tysk basmalt för ren, krispig pilsner, helles och ljus lager.',
  },
  {
    name: 'Viking Pilsner Malt',
    ebc: 4,
    yield: 80,
    type: 'base',
    desc: 'Prisvärd och krispig nordisk pilsnermalt. Utmärkt för lager och ales.',
  },
  {
    name: 'Viking Pale Ale Malt',
    ebc: 6,
    yield: 79,
    type: 'base',
    desc: 'Maltig, fyllig basmalt. Perfekt ryggrad för IPA, APA och hantverks-ales.',
  },
  {
    name: 'Crisp Maris Otter',
    ebc: 6,
    yield: 78,
    type: 'base',
    desc: 'Brittisk golvmaltad basmalt med underbar nötsmak och fyllig brödighet.',
  },
  {
    name: 'Simpson Golden Promise',
    ebc: 6,
    yield: 77,
    type: 'base',
    desc: 'Skotsk basmalt med mjuk, ren och lätt söt maltsmak. Populär i IPA & Pale Ale.',
  },
  {
    name: 'Weyermann Wienermalt / Vienna',
    ebc: 8,
    yield: 78,
    type: 'base',
    desc: 'Gyllene färg och nötsmak. Bra i Märzen, Wiener, Amber och Pale Ales.',
  },
  {
    name: 'Weyermann Münchenmalt I',
    ebc: 15,
    yield: 77,
    type: 'base',
    desc: 'Fyllig brödighet och Maillard-toner. Bra i mörka lagers, bock och mörka ales.',
  },
  {
    name: 'Weyermann Münchenmalt II',
    ebc: 25,
    yield: 76,
    type: 'base',
    desc: 'Mörkare Münchenmalt med djup maltsötma och maltig arom.',
  },
  {
    name: 'Vetemalt (Ljus)',
    ebc: 4,
    yield: 79,
    type: 'base',
    desc: 'Ger fin skumkrona, fyllighet och dis i Hefeweizen, Witbier och NEIPA.',
  },
  {
    name: 'Vetemalt (Mörk)',
    ebc: 10,
    yield: 77,
    type: 'base',
    desc: 'Mörkare vetemalt för Dunkelweizen och fylliga mörka ales.',
  },
  {
    name: 'Rågmalt / Rye Malt',
    ebc: 6,
    yield: 74,
    type: 'base',
    desc: 'Fyllig, kryddig rågkaraktär för råg-IPA, saison ochgårdsöl.',
  },
  {
    name: 'Havregrynsmalt / Oat Malt',
    ebc: 5,
    yield: 72,
    type: 'base',
    desc: 'Maltad havre. Ger en silkeslen munkänsla och mjuk fyllighet i Oatmeal Stout & NEIPA.',
  },
  {
    name: 'Viking Smoked Malt (Rökmalt)',
    ebc: 6,
    yield: 77,
    type: 'base',
    desc: 'Bokrökt basmalt. Subtil rökton. Essentiell i Rauchbier, Gotlandsdricka och rökporter.',
  },

  // Ekologiska & Kultursorter
  {
    name: 'Warbro Kvarn Ölandsvete',
    ebc: 5,
    yield: 75,
    type: 'base',
    desc: 'Ekologisk svensk kultursort från Warbro Kvarn. Rustik, nötaktig vetekaraktär.',
  },
  {
    name: 'Warbro Kvarn Svedjeråg',
    ebc: 7,
    yield: 72,
    type: 'base',
    desc: 'Ekologisk svensk kultursort från Warbro Kvarn. Fyllig, kryddig rågton.',
  },
  {
    name: 'Dinkelmalt (Spelt)',
    ebc: 6,
    yield: 75,
    type: 'base',
    desc: 'Ekologisk dinkelmalt. Fyllig, nötaktig smak med utmärkt skumstabilitet.',
  },

  // Karamelmalter
  {
    name: 'CaraPils / Carafoam (Weyermann)',
    ebc: 4,
    yield: 73,
    type: 'cara',
    desc: 'Ger skumstabilitet och fyllighet utan sötma eller färgändring.',
  },
  {
    name: 'Caramalt / Crystal 20',
    ebc: 40,
    yield: 71,
    type: 'cara',
    desc: 'Lätt kola och mild sötma. Bra i engelska ales och pale ales.',
  },
  {
    name: 'Crystal 60 / Cara 60',
    ebc: 120,
    yield: 70,
    type: 'cara',
    desc: 'Söt karamell och toffee. Klassisk pale ale- och amber ale-ingrediens.',
  },
  {
    name: 'Crystal 120 / Cara 150',
    ebc: 295,
    yield: 68,
    type: 'cara',
    desc: 'Mörk karamell, russin och torkad frukt. Används sparsamt.',
  },
  {
    name: 'Caramünchen I (Weyermann)',
    ebc: 50,
    yield: 70,
    type: 'cara',
    desc: 'Tysk karamelmalt med balanserad brödighet och karamellsötma.',
  },
  {
    name: 'Caramünchen III (Weyermann)',
    ebc: 150,
    yield: 67,
    type: 'cara',
    desc: 'Mörk karamellmalt med toner av torkad frukt, russin och mörk kola.',
  },
  {
    name: 'Caravienne (Castle Malting)',
    ebc: 40,
    yield: 71,
    type: 'cara',
    desc: 'Belgisk karamelmalt med mild sötma och kolatoner.',
  },
  {
    name: 'Viking Cookie Malt',
    ebc: 50,
    yield: 73,
    type: 'cara',
    desc: 'Ger smak av mörka kex, bageri och rostat bröd utan bitterhet.',
  },
  {
    name: 'Château Biscuit (Castle Malting)',
    ebc: 50,
    yield: 72,
    type: 'cara',
    desc: 'Belgisk kexmalt. Ger en doft av rostat bröd och nybakade kex.',
  },
  {
    name: 'Château Special B (Castle Malting)',
    ebc: 300,
    yield: 68,
    type: 'cara',
    desc: 'Intensiv mörk belgisk karamelmalt. Mörk frukt, russin, plommon.',
  },
  {
    name: 'Weyermann Melanoidinmalt',
    ebc: 70,
    yield: 73,
    type: 'cara',
    desc: 'Ger rik Maillard-brödighet och djup röd-brun färg. Bra i bock & märzen.',
  },

  // Rostade malter
  {
    name: 'Brown Malt',
    ebc: 150,
    yield: 70,
    type: 'roasted',
    desc: 'Klassisk brittisk porter-malt. Nöt, rostbröd och mjuk kaffe.',
  },
  {
    name: 'Viking Chocolate Light',
    ebc: 450,
    yield: 65,
    type: 'roasted',
    desc: 'Mjuk choklad- och kaffeton utan strävhet. Utmärkt i porter och stout.',
  },
  {
    name: 'Chokladmalt / Chocolate Malt',
    ebc: 900,
    yield: 65,
    type: 'roasted',
    desc: 'Intensiv mörk choklad och rostat kaffe. Stout och porter.',
  },
  {
    name: 'Carafa Special I (Avhästad)',
    ebc: 600,
    yield: 67,
    type: 'roasted',
    desc: 'Mjukare, avhästat chokladmalt. Ger djup färg utan strävhet.',
  },
  {
    name: 'Carafa Special III (Avhästad)',
    ebc: 1200,
    yield: 62,
    type: 'roasted',
    desc: 'Djup svart färg med mjuk smak. Perfekt för Schwarzbier och mörk IPA.',
  },
  {
    name: 'Svartmalt / Black Patent',
    ebc: 1400,
    yield: 60,
    type: 'roasted',
    desc: 'Extrem rostning. Används sparsamt för färg och sträva toner.',
  },
  {
    name: 'Rostat korn (Roasted Barley)',
    ebc: 1300,
    yield: 60,
    type: 'roasted',
    desc: 'Omaltat rostat korn. Ger torr kaffesmak och vitt skum. Klassiker i Dry Stout.',
  },

  // Adjunkter & Flingor
  {
    name: 'Havreflingor (Flaked Oats)',
    ebc: 3,
    yield: 65,
    type: 'adjunct',
    desc: 'Omaltad havre. Ger silkig textur och dimighet i NEIPA och Oatmeal Stout.',
  },
  {
    name: 'Veteflingor (Flaked Wheat)',
    ebc: 3,
    yield: 68,
    type: 'adjunct',
    desc: 'Protein och disighet för Witbier och Hazy IPA.',
  },
  {
    name: 'Kornflingor (Flaked Barley)',
    ebc: 3,
    yield: 65,
    type: 'adjunct',
    desc: 'Ger fyllighet och fin skumkrona i Stouts och Bitters.',
  },
  {
    name: 'Majsflingor (Flaked Corn)',
    ebc: 2,
    yield: 65,
    type: 'adjunct',
    desc: 'Neutral sötma för Cream Ale och amerikansk lager.',
  },

  // Socker, Extrakt & Tillsatser
  {
    name: 'Sackaros (Strösocker)',
    ebc: 0,
    yield: 100,
    type: 'sugar',
    desc: 'Rent socker. Ökar alkoholhalten utan att ge kropp.',
  },
  {
    name: 'Laktos (Mjölksocker)',
    ebc: 0,
    yield: 70,
    type: 'sugar',
    desc: 'Icke-jäsbart socker. Ger fyllig sötma och krämig munkänsla i Milkshake IPA & Stout.',
  },
  {
    name: 'Kandissocker (Ljust)',
    ebc: 5,
    yield: 96,
    type: 'sugar',
    desc: 'Belgisk kandis. Ökar alkoholhalten och torkar ut slutsmaken i Tripel & Saison.',
  },
  {
    name: 'Kandissocker (Mörkt)',
    ebc: 400,
    yield: 96,
    type: 'sugar',
    desc: 'Mörk belgisk kandis. Ger fylliga toner av russin, plommon och sirap.',
  },
  {
    name: 'Honung',
    ebc: 3,
    yield: 75,
    type: 'sugar',
    desc: 'Ger subtil honungsarom. Tillsätts bäst mot slutet av koket eller i fermentorn.',
  },
  {
    name: 'Maltextrakt (DME, Ljust)',
    ebc: 6,
    yield: 97,
    type: 'sugar',
    desc: 'Torrt maltextrakt för snabb-bryggning och jäststarter.',
  },
  {
    name: 'Maltextrakt (LME, Ljust)',
    ebc: 6,
    yield: 80,
    type: 'sugar',
    desc: 'Flytande maltextrakt för enkelt bryggande.',
  },
];
